import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useDropzone } from "react-dropzone";
import { AppContext } from "../context/AppProvider";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function UploadInvoiceDialog({ open, onClose }) {
  const [atsFile, setAtsFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const context = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const handleChangeAtsFile = (files) => {
    setAtsFile(files[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => handleChangeAtsFile(acceptedFiles),
    accept: { 'application/pdf': ['.pdf'] },
    maxFiles: 1
  });

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const formData  = new FormData();
      formData.append('ats', atsFile);
  
      const response = await fetchWithInterceptor('/api/ats/upload-invoice', {
        method: 'POST',
        body: formData,
        headers: {
          'x-access-token': authContext.getToken()
        },
      });
      setLoading(false);
      if (response.ok) {
        onClose(true);
        context.showMessage("Invoice uploaded successfully. Comparison will start shortly.", "success");
      } else {
        const error = await response.json();
        context.showMessage(error?.message || "Invalid file", "error");
      }
    } catch (error) {
      context.showMessage("Invalid file", "error");
      setLoading(false);
    }
  };

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="sm"
      aria-labelledby="delete-dialog"
      open={open}
    >
      <DialogTitle id="delete-dialog">ATS Invoice</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ width: '100%' }}>
          <Grid size={{ xs: 12 }}>
            <div
              {...getRootProps()}
              style={{
                border: '2px dashed #ccc',
                borderRadius: 4,
                padding: 20,
                textAlign: 'center',
                cursor: 'pointer',
                minHeight: 120,
              }}
            >
              <input {...getInputProps()} />
              <Typography variant="h5">
                Drag and drop a ATS Invoice PDF file here or click
              </Typography>
              <CloudUploadIcon sx={{ fontSize: 36, mt: 2 }} />
            </div>
            <Typography variant="subtitle1" sx={{ mt: 2 }}>
              {`Uploaded file: ${atsFile ? atsFile.name : '-'}`}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading} sx={{ width: 100, height: 36.5 }}>
          {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
